import React from 'react';
import { DemoButtons } from '../DemoButtons/DemoButtons';
import { MapReport } from '../MapReport/MapReport';
import styles from './VisitingHistory.module.css';

export const VisitingHistory = ({ userVisits, isMobile }) => (
  <div className={styles.wrapper}>
    <h2 className={styles.title}>Your visiting history</h2>
    <div
      className={
        userVisits.length === 1 ? styles.report__center : styles.report
      }
    >
      {userVisits.slice(1, 7).map((visit, index) => (
        <MapReport
          visit={visit}
          mode="horizontal"
          key={index}
          reportNumber={index + 1}
          isMobile={isMobile}
        />
      ))}
    </div>
    <DemoButtons isMobile={isMobile} />
  </div>
);
